import React from 'react';
import { ImageEditorProvider } from './context';
import ImageEditor from './ImageEditor';
export default props => (
  <ImageEditorProvider>
    <ImageEditor {...props} />
  </ImageEditorProvider>
);
